

































































import { Component, Mixins } from "vue-property-decorator";
import RulesMixin from "@/mixins/RulesMixin";
import UserService from "@/services/UserService";
import AppFormWrapper from "@/layouts/AppFormWrapper.vue";
import { getFirstQueryValue } from "@/utils/queryParams";

@Component({
  components: {
    AppFormWrapper,
  },
})
export default class PasswordResetView extends Mixins(RulesMixin) {
  isValid = true;
  password = "";
  confirmPassword = "";
  showPassword = false;

  private async handleSubmit(): Promise<any> {
    try {
      await UserService.setPassword(this.token, this.confirmPassword);
      this.$snackbarSuccess(this.$tc("passwordWasUpdated"));
      await this.$router.push({
        name: "login",
        params: {
          username: this.email,
        },
      });
    } catch (err) {
      this.$snackbarError(this.$tc("auth.resetFailed", 1));
    }
  }

  get token(): string {
    return getFirstQueryValue(this.$route.query.token) ?? "";
  }

  get isTokenValid(): boolean {
    return this.token.length > 0;
  }

  get welcomeText(): string {
    const displayName = getFirstQueryValue(this.$route.query.displayName) ?? "";

    return this.$t("welcomeName", {
      name: displayName,
    }) as string;
  }

  get email(): string {
    return getFirstQueryValue(this.$route.query.email) ?? "";
  }

  get isNewUser(): boolean {
    return getFirstQueryValue(this.$route.query.isNew) === "true";
  }

  get passwordIsSame(): true | string {
    return this.password === this.confirmPassword
      ? true
      : this.$tc("field.error.passwordsSame");
  }
}
